import { render, staticRenderFns } from "./ctrlcontact.vue?vue&type=template&id=5fe71cc2"
import script from "./ctrlcontact.vue?vue&type=script&lang=js"
export * from "./ctrlcontact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports